module.exports = __webpack_public_path__ + "static/media/tree_vertical_btn.fc4d21d2.svg";